export default __webpack_public_path__ + "static/media/web_screen_meetings_ptBR.3de5b4bf.png";